module.exports = __webpack_public_path__ + "img/greyDownArrow.3328d09a.svg";